import { plural, t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
import { useField } from 'formik';
export function PermissionAlert() {
    const [permissionField] = useField('addDocumentPermission');
    const permissions = permissionField.value.length;
    const title = t({
        message: 'Missing access',
        comment: 'task create form - assignee permission alert title',
    });
    const message = plural(permissions, {
        one: '# user does not have access to this document. You will have to grant them access to the document separately after creating the task.',
        other: '# users do not have access to this document. You will have to grant them access to the document separately after creating the task.',
    });
    return <Alert appearance="warning" title={title} message={message}/>;
}
